import React from 'react';
import './App.css';
import MainPage from "./pages/MainPage";
import {ChakraProvider} from "@chakra-ui/react";
import {Provider} from "react-redux";
import {store} from "./stateManagement/store";
import { Sentry } from './sentry';

function FallbackComponent() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Something went wrong.</h2>
      <p>The error has been reported. Please refresh the page or try again later.</p>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackComponent />} showDialog>
      <Provider store={store}>
        <ChakraProvider resetCSS={false}>
          <MainPage/>
        </ChakraProvider>
      </Provider>
    </Sentry.ErrorBoundary>
  );
}
export default App;
